export default {
  mariaCampaign: {
    title: '',
    description: '',
    products: [],
    offer_sales: [],
    offerSelected: '',
  },
}
